import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JoinedCampaignsComponent } from './joined-campaigns.component';
import { ButtonModule } from '../form-group/button/button.module';
import { RouterModule } from '@angular/router';


@NgModule({
  declarations: [JoinedCampaignsComponent],
  imports: [
    CommonModule,
    ButtonModule,
    RouterModule
  ],
  exports: [
    JoinedCampaignsComponent
  ]
})
export class JoinedCampaignsModule { }
